<template>
  <v-container class="pa-0">

    <v-row class="font-weight-bold" no-gutters>
      <v-col cols="12">{{ $t('uso') }}</v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" class="ml-4">{{ escenario.usoExterior.nombre }}</v-col>
    </v-row>

    <v-row class="font-weight-bold" no-gutters>
      <v-col cols="12">{{ $t('zona') }}</v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" class="ml-4">{{ escenario.tipoZonaExterior.nombre }}</v-col>
    </v-row>

    <v-row class="font-weight-bold" no-gutters>
      <v-col cols="12">{{ $t('soporte') }}</v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" class="ml-4">{{ escenario.tipoSoporteExterior.nombre }}</v-col>
    </v-row>

    <v-row class="font-weight-bold" no-gutters>
      <v-col cols="12">{{ $t('helada') }}</v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" class="ml-4">{{ escenario.riesgoHeladaExterior.nombre }}</v-col>
    </v-row>

    <v-row class="font-weight-bold" no-gutters>
      <v-col cols="12">{{ $t('mant') }}</v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" class="ml-4">{{ escenario.frecMantExterior.nombre }}</v-col>
    </v-row>

  </v-container>
</template>

<script>
export default {
  name: "EscenarioExteriorR",
  props: {
    escenario: {type: Object, required: true}
  }
}
</script>

<style scoped>

</style>

<!-- @formatter:off -->
<i18n>
{
  "es": {
    "uso": "Uso",
    "zona": "Tipo de zona",
    "soporte": "Tipo de soporte",
    "helada": "Riesgo de helada",
    "mant": "Frecuencia de mantenimiento"
  }
}
</i18n>
<!-- @formatter:on -->